import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    start: null
  },
  setup(__props: any) {

const props = __props as {
  start: number;
}



function timeSince() {
  var seconds = Math.floor((Date.now() - props.start) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + ' years';
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + ' months';
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + ' days';
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + ' hours';
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + ' minutes';
  }
  return Math.floor(seconds) + ' seconds';
}

const display = ref(timeSince());
const timeout = ref();

function getTimeoutRate() {
  if (display.value.includes('seconds')) {
    return 1000;
  }
  if (display.value.includes('minutes')) {
    return 1000 * 60;
  }
  if (display.value.includes('hours')) {
    return 1000 * 60 * 60;
  }
  return 1000;
}

function applyTimeout() {
  display.value = timeSince();
  timeout.value = setTimeout(applyTimeout, getTimeoutRate());
}

onMounted(() => {
  applyTimeout();
});

onBeforeUnmount(() => {
  clearTimeout(timeout.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _toDisplayString(display.value) + " ago", 1))
}
}

})